export default _getFieldInfo;

function _getFieldInfo(fieldName) {
  let parts = fieldName.split('.');
  let index = parts?.[2];
  let indexIsNumber =
    parts.length > 2 && typeof index !== 'object' && !isNaN(index);
  const baseName = indexIsNumber ? [parts[0], parts[1]].join('.') : fieldName;
  return {
    baseName,
    baseNameWithIndex: baseName + '.' + index,
    index: indexIsNumber ? parseInt(index) : null,
    isMulti: indexIsNumber,
    childName: parts[parts.length - 1],
  };
}
